// With a lot of help from:
// https://webdesign.tutsplus.com/tutorials/how-to-intersection-observer--cms-30250

class Animasection {
    queues = [];
    queueRunnerId = -1;

    constructor(options = {}) {

        // A nice way to initialise default options
        this.options = Object.assign(this, {
            root: null, // relative to document viewport
            rootMargin: '5%', // margin around root. Values are similar to css property. Unitless values not allowed
            threshold: 0.5 // visible amount of item shown in relation to root (higher values can cause problems)
        }, options);

        // This is the guy who will tell us when an element intersects with the viewport
        const observerFunc = (entries) => {
            this.onChange(entries);
        }
        this.observer = new IntersectionObserver(observerFunc, this.options);
    }

    /**
     * Observe all elements that contain either data-class-in or data-class-out
     */
    observeAll() {
        let images = document.querySelectorAll('[data-class-in], [data-class-out]');
        images.forEach(img => this.observer.observe(img));
    }

    /**
     * Unobserve all elements that contain either data-class-in or data-class-out
     * Useful for optimisation / page transitions with swup / turbolinks
     */
    unobserveAll() {
        let images = document.querySelectorAll('[data-class-in], [data-class-out]');
        images.forEach(img => this.observer.unobserve(img));
    }

    /**
     * The intersection observer will fire this function
     * when at least one of our elements intersects / leaves the viewport
     */
    onChange(changes, observer) {
        /*
         * 'split' turns our data attribute string into an array, and the spread operator (three dots)
         * deconstructs it into the format that we need for manipulating the element's 'classList'
         */
        let splitAttr = (change, attributeName) => {
            let attrs = change.target.getAttribute(attributeName);
            return attrs ? attrs.split(' ') : [];
        };
        changes.forEach(change => {
            let isLoop = !!change.target.getAttribute('data-animation-loop')
            let isFinished = !!change.target.getAttribute('data-animation-finished')
            let isQueue = !!change.target.getAttribute('data-animation-queue');
            const actionAnimationFunc = () => {
                if (change.isIntersecting) {
                    if (!isLoop) {
                        change.target.setAttribute('data-animation-finished', 1);
                    }
                    if (!isLoop && isFinished) { //ループじゃ無いなら1度で終わり
                        return null;
                    }
                    return () => {
                        change.target.classList.remove(...splitAttr(change, 'data-class-out'))
                        change.target.classList.add(...splitAttr(change, 'data-class-in'))
                    }
                } else {
                    if (isLoop) {
                        return () => {
                            change.target.classList.remove(...splitAttr(change, 'data-class-in'))
                            change.target.classList.add(...splitAttr(change, 'data-class-out'))
                        }
                    }
                }
                return null;
            }
            const fn = actionAnimationFunc();
            if (fn) {
                if (isQueue) {
                    this.queues.push(fn);
                    this.checkQueue();
                } else {
                    fn();
                }
            }
        })
    }

    checkQueue() {
        if (this.queues.length > 0) {
            if (this.queueRunnerId < 0) {
                this.queueRunnerId = setInterval(() => {
                    this.queues.shift()();
                    this.checkQueue();
                }, 100);
            }
        } else {
            clearInterval(this.queueRunnerId);
            this.queueRunnerId = -1;
        }
    }
}

export default new Animasection()
